import { UnattendedLogoutButton } from "~/components/UnattendedLogoutButton";
import { type WithClassNameAndChildren } from "~/lib/utils";

import { Screen } from "./screen";

type ScreenIssueProps = WithClassNameAndChildren & {
  bottomSlot?: React.ReactNode;
};

const ScreenIssueRoot = ({
  children,
  className,
  bottomSlot
}: ScreenIssueProps) => {
  return (
    <Screen className={className}>
      <Screen.TopAction>
        <UnattendedLogoutButton />
      </Screen.TopAction>

      <Screen.Visual>
        <img
          src="/images/pos-kitchen-chef.svg"
          alt="POS Chef"
          className="max-w-md object-none"
        />
      </Screen.Visual>

      <Screen.Content>{children}</Screen.Content>

      <Screen.BottomAction>{bottomSlot}</Screen.BottomAction>
    </Screen>
  );
};

// Namespace pattern export
export const ScreenIssue = Object.assign(ScreenIssueRoot, {
  Title: Screen.Title,
  Text: Screen.Text,
  Button: Screen.Button
});
